import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiConfig from "../axiosConfig";

const initialState = {
	bulkPurchaseList: [],
	hasNextPage: false,
	status: null,
	error: null,
};

export const getAllBulkPurchase = createAsyncThunk("bulkPurchaseManagement/fetchList", async ({ country }) => {

	const response = await apiConfig
		.get(`bulk-purchase/getBulkPurchases/${country}`)
		.then((response) => response)
		.catch((error) => error);

	return response.data;
});

export const addBulkPurchase = createAsyncThunk("bulkPurchaseManagement/addBulkPurchase", 
	async (payload, { rejectWithValue }) => {
		try {
			console.log("add bulk purchase", payload);
			
			const configs = {
				headers: {
					'SSO-Access-Token': payload.ssoAccessToken,
				}
			}
			
			const response = await apiConfig.post(`bulk-purchase/add`, payload.data, configs);
			return response.data;
		} catch (error) {
			return rejectWithValue(error);
		}
});

const bulkPurchaseManagementSlice = createSlice({
	name: "bulkPurchase",
	initialState,
	reducers: {},
	extraReducers: {
		[getAllBulkPurchase.pending]: (state) => {
			state.status = "loading";
		},
		[getAllBulkPurchase.fulfilled]: (state, action) => {
			const response = action.payload;
			if (response?.status === "OK") {
				state.bulkPurchaseList = [];
				state.status = "OK";
				// state.hasNextPage = response.fetchCount === action. false;
				state.bulkPurchaseList = response.data;
			} else {
				state.status = "failed";
				state.bulkPurchaseList = [];
				state.error = action?.error?.message || action?.payload?.message;
				state.hasNextPage = false;
			}
		},
		[getAllBulkPurchase.rejected]: (state, action) => {
			state.status = "failed";
			state.error = action.error.message;
			state.hasNextPage = false;
		},
	},
});

export const bulkPurchaseManagementActions = bulkPurchaseManagementSlice.actions;
export default bulkPurchaseManagementSlice.reducer;
